import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search, FolderOpen, Plus } from "lucide-react";
import { CATEGORIES, categoryTestId, FADE_UP } from "./contentModel";

export const ContentFilters = ({ query, setQuery, category, setCategory }) => (
  <div className="flex flex-col sm:flex-row gap-4">
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500" />
      <Input placeholder="Search content..." value={query} onChange={(e) => setQuery(e.target.value)}
        className="pl-10 bg-white/5 border-white/10 text-white placeholder:text-gray-500" data-testid="content-search-input" />
    </div>
    <div className="flex gap-2 flex-wrap">
      {CATEGORIES.map((c) => (
        <Button key={c} variant="ghost" size="sm" onClick={() => setCategory(c)} data-testid={categoryTestId(c)}
          className={`rounded-full px-4 ${category === c ? "bg-ism-teal/20 text-ism-teal border border-ism-teal/30" : "text-gray-400 hover:text-white hover:bg-white/5"}`}>
          {c === "all" ? "All" : c}
        </Button>
      ))}
    </div>
  </div>
);

export const ContentEmptyState = ({ onCreate }) => (
  <motion.div {...FADE_UP} className="glass-card rounded-2xl p-12 text-center" data-testid="content-empty-state">
    <div className="w-20 h-20 rounded-2xl bg-ism-teal/10 flex items-center justify-center mx-auto mb-6 border border-ism-teal/20">
      <FolderOpen className="h-10 w-10 text-ism-teal" />
    </div>
    <h3 className="text-xl font-medium text-white mb-2">No Content Yet</h3>
    <p className="text-gray-400 mb-6 max-w-md mx-auto">
      Your content library is empty. Use the Hunt and Farm actions to find leads, then create personalized content for outreach.
    </p>
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      <Button onClick={onCreate} className="bg-ism-teal hover:bg-ism-teal-light text-white" data-testid="create-first-content-btn">
        <Plus className="h-4 w-4 mr-2" />
        Create Your First Content
      </Button>
    </div>
  </motion.div>
);
